import { CustomFieldAttributes, CustomFieldField, CustomFieldResource } from '@/types'
import { CreateCustomFieldMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { ErrorMessage, Field, Label } from '../base/fieldset'
import { Selector as ResourceTypeSelector } from './resource_type/selector'
import { Selector as FieldTypeSelector } from './field_type/selector'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    fieldErrors,
    attributes,
    setAttributes
  } = useForm<CreateCustomFieldMutation, CustomFieldAttributes, never, never>({
    defaultValues: {
      name: '',
      enabled: true,
      fieldType: CustomFieldField.Text,
      resourceType: CustomFieldResource.AssetType
    },
    mutation: CreateMutation,
    resultKey: 'createCustomField',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
      <div className="grid grid-cols-2 gap-6">
        <Field>
          <Label>Resource</Label>
          <ResourceTypeSelector
            invalid={!!fieldErrors?.resourceType}
            value={attributes.resourceType}
            onChange={value => setAttributes({ ...attributes, resourceType: value?.id as CustomFieldResource || CustomFieldResource.AssetType }) }
          />
          { fieldErrors?.resourceType && <ErrorMessage>{ fieldErrors?.resourceType }</ErrorMessage> }
        </Field>
        <Field>
          <Label>Field type</Label>
          <FieldTypeSelector
            invalid={!!fieldErrors?.fieldType}
            value={attributes.fieldType}
            onChange={value => setAttributes({ ...attributes, fieldType: value?.id as CustomFieldField || CustomFieldField.Boolean }) }
          />
          { fieldErrors?.fieldType && <ErrorMessage>{ fieldErrors?.fieldType }</ErrorMessage> }
        </Field>
      </div>
      { formBuilder.buildField({ name: 'Enabled', field: 'enabled', type: 'switch' }) }
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
